import { ArrowDown } from "lucide-react";
import { Reveal, MaskedHeading, ParallaxImage } from "../Reveal";
import { IDENTIFICATION, IMAGES } from "../../data/content";
import { track } from "../../lib/analytics";

export default function Identification() {
  return (
    <section
      className="section bg-marine py-24 md:py-40 relative"
      data-testid="identification-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="chapter-num">CHAPITRE 02 — RECONNAISSANCE</span>
        <MaskedHeading
          tag="h2"
          className="font-display font-medium text-[clamp(2.1rem,4.6vw,3.8rem)] leading-tight tracking-tight text-pearl mt-8 max-w-4xl"
          lines={["Peut-être que quelque chose", "en toi reconnaît cela…"]}
        />

        <div className="mt-16 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7 flex flex-col gap-9 md:gap-11">
            {IDENTIFICATION.map((phrase, i) => (
              <Reveal
                key={i}
                delay={(i % 3) * 0.08}
                className={`border-l-2 border-aqua/40 pl-6 ${
                  i % 2 ? "lg:ml-10" : ""
                }`}
              >
                <p className="font-display text-[1.5rem] md:text-[2rem] leading-snug text-pearl/90">
                  {phrase}
                </p>
              </Reveal>
            ))}
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <ParallaxImage
              src={IMAGES.face}
              alt="Visage adulte à moitié immergé dans la mer, regard tourné vers l'horizon"
              className="aspect-[4/5] rounded-sm"
            />
          </div>
        </div>

        <Reveal delay={0.1} className="mt-20 max-w-3xl">
          <p className="text-aqua text-lg md:text-xl leading-relaxed">
            La Traversée commence précisément là : non pas quand tu possèdes toutes les
            réponses, mais quand tu acceptes d'écouter autrement.
          </p>
          <a
            href="#passages"
            className="btn btn--ghost mt-9"
            data-testid="discover-passages-cta"
            onClick={() => track("secondary_cta_click", { target: "passages" })}
          >
            DÉCOUVRIR LES 3 PASSAGES
            <ArrowDown size={18} strokeWidth={1.6} />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
